    <div class="numbersComp comp">
    <div class="container numbers ">
        <p class="numbersTitle">A look at Klickit by the numbers</p>


        <div class="numbersBody">
            <div class="numbersBodyCard">
                <img src="../../../assets/images/numbers/1.png"/>
                <p class="cardNumber">1.5M+</p>
                <p class="numbersTitle cardNumberTitle">Students</p>
            </div>


            <div class="numbersBodyCard">
                <img src="../../../assets/images/numbers/2.png"/>
                <p class="cardNumber">55K+</p>
                <p class="numbersTitle cardNumberTitle">Schools</p>
            </div>


            <div class="numbersBodyCard">
                <img src="../../../assets/images/numbers/3.svg"/>
                <p class="cardNumber">2.5B+</p>
                <p class="numbersTitle cardNumberTitle">Amount Processed</p>
            </div>
        </div>
    </div>
</div>